import React, { useContext, useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { GlobalContext } from '../../context/provider';
import { LoginContext } from '../../../home/logincontext';
import { AiOutlineCheckCircle } from "react-icons/ai";
import { MdEditNote } from "react-icons/md";
import numberbeautifuly from '../../../utils/numberbeautify';

const Expense_report_list = () => {
    const { reportState, reportDispatch } = useContext(GlobalContext);
    return (
        <div dir='rtl'>
            <Container>
                <Row className='justify-content-md-center mt-5'>
                    <Col lg={11}>
                        <Table striped bordered hover size="lg" style={{ textAlign: 'center' }} >
                            <thead>
                                <tr>
                                    <th>ناوی کەس و مەبەستی خەرجی</th>
                                    <th>بڕی پارە</th>
                                    <th>شوێن و جۆری خەرجی</th>
                                    <th>بەروار</th>
                                    <th>تێبینی</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: 12 }}>
                                {reportState.expense_report.map((lis) => (
                                    <tr style={{ cursor: 'pointer' }}>
                                        <td>{lis.project_expense_name}</td>
                                        <td>{numberbeautifuly(lis.project_expense_amount)} IQD</td>
                                        <td>{lis.project_expense_type}</td>
                                        <td>{lis.project_expense_date}</td>
                                        <td>{lis.project_expense_note}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Expense_report_list